module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "my-4"
  }, [_c('document-type-header', {
    attrs: {
      "title": _vm.title,
      "statusLabel": _vm.statusLabel,
      "statusIcon": _vm.statusIcon,
      "subTitle": _vm.subTitle
    }
  }, [_vm._t("default")], 2), _vm._v(" "), _c('div', {
    staticClass: "mt-2 form-group"
  }, [_c('multiple-documents-upload', {
    attrs: {
      "multiple": _vm.multipleDocs,
      "canAdd": _vm.canAdd,
      "canDelete": _vm.canDelete,
      "canReplace": _vm.canReplace || _vm.canForceReplace,
      "id": _vm.name,
      "hasError": _vm.fileHasError,
      "errorMsg": _vm.$t('errors.invalid_rib')
    },
    on: {
      "resetError": _vm.resetError
    },
    model: {
      value: (_vm.uploadedFiles),
      callback: function($$v) {
        _vm.uploadedFiles = $$v
      },
      expression: "uploadedFiles"
    }
  })], 1), _vm._v(" "), (_vm.isVisible) ? _c('div', {
    staticClass: "my-4"
  }, [(_vm.isRIB) ? _c('div', [_c('div', {
    staticClass: "information_check_no"
  }, [_vm._v("\n        " + _vm._s(_vm.$t('iframe_page.check_informations_3')) + "\n      ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('adaptative-placeholder-input', {
    attrs: {
      "label": _vm.$t('iframe_page.iban'),
      "inputFormating": _vm.formateIBAN,
      "hasError": _vm.ibanHasError,
      "errorMessage": _vm.ibanErrorMessage
    },
    model: {
      value: (_vm.iban),
      callback: function($$v) {
        _vm.iban = $$v
      },
      expression: "iban"
    }
  }), _vm._v(" "), _c('adaptative-placeholder-input', {
    attrs: {
      "label": _vm.$t('iframe_page.bic'),
      "hasError": _vm.bicHasError,
      "errorMessage": _vm.bicErrorMessage
    },
    model: {
      value: (_vm.bic),
      callback: function($$v) {
        _vm.bic = $$v
      },
      expression: "bic"
    }
  }), _vm._v(" "), _c('adaptative-placeholder-input', {
    attrs: {
      "label": _vm.$t('iframe_page.banque'),
      "hasError": _vm.bankHasError,
      "errorMessage": _vm.bankErrorMessage
    },
    model: {
      value: (_vm.bank),
      callback: function($$v) {
        _vm.bank = $$v
      },
      expression: "bank"
    }
  }), _vm._v(" "), _c('adaptative-placeholder-input', {
    attrs: {
      "label": _vm.$t('iframe_page.bank_address'),
      "hasError": _vm.bankAddressHasError,
      "errorMessage": _vm.bankAddressErrorMessage
    },
    model: {
      value: (_vm.bankAddress),
      callback: function($$v) {
        _vm.bankAddress = $$v
      },
      expression: "bankAddress"
    }
  }), _vm._v(" "), _c('adaptative-placeholder-input', {
    attrs: {
      "label": _vm.$t('iframe_page.bank_zip'),
      "hasError": _vm.bankZipHasError,
      "errorMessage": _vm.bankZipErrorMessage
    },
    model: {
      value: (_vm.bankZip),
      callback: function($$v) {
        _vm.bankZip = $$v
      },
      expression: "bankZip"
    }
  }), _vm._v(" "), _c('adaptative-placeholder-input', {
    attrs: {
      "label": _vm.$t('iframe_page.bank_city'),
      "hasError": _vm.bankCityHasError,
      "errorMessage": _vm.bankCityErrorMessage
    },
    model: {
      value: (_vm.bankCity),
      callback: function($$v) {
        _vm.bankCity = $$v
      },
      expression: "bankCity"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "validation-btn LMSG-background-color",
    attrs: {
      "type": "button",
      "disabled": _vm.fileHasError || _vm.showLoader
    },
    on: {
      "click": _vm.onClick
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t('creation_forms.vldt')) + "\n    ")])]) : _vm._e()], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-2b34a179", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2b34a179","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/LMSGiframe/components/DocumentTypeForm.vue
// module id = 2315
// module chunks = 2